import { compose } from 'ramda';

const trim = (str) => str?.replace(/^\s+|\s+$/g, '') || '';

const ascii = (str) =>
  str
    .replace(/[áàâä]/g, 'a')
    .replace(/[éèêë]/g, 'e')
    .replace(/[íìîï]/g, 'i')
    .replace(/[óòôö]/g, 'o')
    .replace(/[úùûü]/g, 'u')
    .replace(/ç/g, 'c')
    .replace(/ñ/g, 'n')
    .replace(/œ/g, 'oe')
    .replace(/æ/g, 'ae');

export const formatId = compose(
  (str) => str.replace(/\W/g, '').toLowerCase(),
  ascii,
  trim
);
